import { Paper } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { observer } from 'mobx-react';
import React, { useState } from 'react';
import { OneToolCardBorder } from './oneToolCard';
import { PropertyInformationAccordion } from './propertyInformationAccordion';
import { PropertyFormStore } from '../../stores/fixFlip/propertyFormStore';
import { IQuoteTypeStore } from '../../stores/common/iQuoteTypeStore';

export interface PropertyInformationFormProps {
  store: PropertyFormStore;
  onDeleteClick: (propertyKey: string) => void;
  removeButtonDisabled?: boolean;
  showActions: boolean;
  quoteTypeStore: IQuoteTypeStore;
}

interface PropertyInformationCardProps {
  store: IQuoteTypeStore;
  propertyFormStore: PropertyFormStore;
  showActions?: boolean;
  PropertyInformationForm: React.FC<PropertyInformationFormProps>;
}

export const PropertyInformationCard = observer(
  ({
    store,
    propertyFormStore,
    showActions = true,
    PropertyInformationForm,
  }: PropertyInformationCardProps) => {
    const editMode = propertyFormStore.form.meta.editMode;
    const removeButtonDisabled =
      store.propertiesStore.propertyFormStores.length <= 1;

    const [expanded, setExpanded] = useState(false);

    const handleDelete = propertyKey => {
      store.propertiesStore.removeProperty(propertyKey);
    };

    return (
      <OneToolCardBorder>
        {editMode && (
          <PropertyInformationForm
            store={propertyFormStore}
            quoteTypeStore={store}
            onDeleteClick={handleDelete}
            showActions={showActions}
            removeButtonDisabled={removeButtonDisabled}
          />
        )}
        {!editMode && (
          <PropertyInformationAccordion
            store={propertyFormStore as any}
            onDeleteClick={handleDelete}
            showActions={showActions}
            removeButtonDisabled={removeButtonDisabled}
            expanded={expanded}
            onExpand={expanded => setExpanded(expanded)}
            onEdit={() => propertyFormStore.setEditMode(true)}
          />
        )}
      </OneToolCardBorder>
    );
  }
);
